import { render, staticRenderFns } from "./Sabonner.vue?vue&type=template&id=9928178c&"
import script from "./Sabonner.vue?vue&type=script&lang=js&"
export * from "./Sabonner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports